import { useSelectedNetwork } from "@umami/state";
import { TezosBridge } from "@umami/swap";
import { useMemo } from "react";

export const useTezosBridge = () => {
  const currentNetwork = useSelectedNetwork();

  const bridge = useMemo(() => {
    const network = currentNetwork.name === "mainnet" ? "mainnet" : "shadownet";

    return new TezosBridge({ network });
  }, [currentNetwork.name]);

  return {
    bridge,
    depositXtz: async (amount: bigint) => bridge.depositXtz(amount),
    withdrawXtz: async (
      amount: bigint,
      opts?: { fastWithdrawal?: boolean; tezosAddress?: string; fastWithdrawalContract?: string }
    ) => bridge.withdrawXtz(amount, opts),
  };
};
